import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { approverApi } from 'src/app/config/api-url';

@Injectable({
  providedIn: 'root'
})
export class ApproverService {

  constructor(private apiService: ApiService) {}

  getActivityList() {
    return this.apiService.get(approverApi.getActivityList);
  }

  getActivityGridData(req: string) {
    return this.apiService.get(`${approverApi.getActivityGridData}${req}`);
  }

  updateStatus(req: string) {
    return this.apiService.post(`${approverApi.approverUpdateStatus}${req}`);
  }

  getApprovalCount(req: string) {
    return this.apiService.get(`${approverApi.getApprovalCount}${req}`);
  }

  getApprovalListBySearch(req: string) {
    return this.apiService.get(`${approverApi.getApproverlistBySearch}${req}`);
  }
}
